import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import urlConfig from "../../mixins/url";
import jwt_decode from "jwt-decode";
import CoolingTunnel from "./modules/coolingTunnelModule";
import CoatingProduct from "./modules/coatingProductModule";
import CoatingProductRecipe from "./modules/coatingProductRecipeModule";

Vue.use(Vuex);
const urls = urlConfig.data().url;
const serverUrl = urlConfig.data().url.serverUrl;

const store = new Vuex.Store({
  modules: {
    CoolingTunnel: CoolingTunnel,
    coatingProduct: CoatingProduct,
    coatingProductRecipe: CoatingProductRecipe
  },
  state: {
    isLoaded: false,
    status: "",
    token: localStorage.getItem("token"),
    tokenExpirationDate: localStorage.getItem("tokenExpirationDate"),
    delivery: {},
    baseForm: {},
    deliveryFormData: {
      countries: [],
      producers: [],
      deliveryQuestions: [],
      rawMaterialTypes: [],
      vehicles: [],
    },
    couvertureFormData: {
      mills: [],
      recipes: [],
      rawMaterialTypes: [],
    },
    productionHall: {
      barrels: [],
      recipeCoating: [],
    },
    userFormData: {
      roles: [],
    },
  },
  mutations: {
    //Synchroniczne akcje
    setToken(state, token) {
      localStorage.setItem("token", token);
      state.token = token;
      var decodedToken = jwt_decode(state.token);
      state.tokenExpirationDate = decodedToken.exp * 1000;
      localStorage.setItem("tokenExpirationDate", state.tokenExpirationDate);
    },
    logout(state) {
      state.token = undefined;
      state.tokenExpirationDate = undefined;
      localStorage.removeItem("token");
    },

    isLoggedIn(state) {
      if (state.token == undefined) {
        return false;
      }
      if (Date.now() >= state.tokenExpirationDate) {
        state.token = "";
        localStorage.removeItem("token");
        return false;
      }
      return true;
    },
    setCurrentDelivery(state, data) {
      state.delivery = data;
    },
    setProductionHallData(state, data) {
      state.productionHall.barrels = data.barrels;
      state.productionHall.recipeCoating = data.recipeCoating;
    },
    setUserFormData(state, data) {
      state.userFormData.roles = data.roles;
    },
    setDeliveryFormData(state, data) {
      state.deliveryFormData.countries = data.countries;
      state.deliveryFormData.producers = data.producers;
      state.deliveryFormData.deliveryQuestions = data.deliveryQuestions;
      state.deliveryFormData.rawMaterialTypes = data.rawMaterialTypes;
      state.deliveryFormData.vehicles = data.vehicles;
    },
    setCouvertureFormData(state, data) {
      state.couvertureFormData.mills = data.mills;
      state.couvertureFormData.recipes = data.recipes;
      state.couvertureFormData.rawMaterialTypes = data.rawMaterialTypes;
    },
    addVehicle(state, data) {
      state.deliveryFormData.vehicles.push({ id: data.id, name: data.name });
    },
    addRawMaterilType(state, data) {
      state.deliveryFormData.rawMaterialTypes.push({ id: data.id, name: data.name });
    },
  },
  actions: {
    loadInitialData(context) {
      Promise.all([
        context.dispatch("getCuvertureFormData"),
        context.dispatch("getProductionHallData"),
        context.dispatch("CoolingTunnel/getCoolingTunnels"),
        context.dispatch("coatingProductRecipe/getRecipes"),
      ]).then(() => {
        context.state.isLoaded = true;
      });
    },
    //Asynchroniczne akcje
    register({ commit }, user) {
      var url = `${serverUrl}${urls.Auth.Register}`;
      return axios
        .post(url, {
          name: user.name,
          password: user.password,
          roleId: user.roleId,
        })
        .then(
          (response) => {
            commit("registerSuccess");
            return Promise.resolve(response.data);
          },
          (error) => {
            commit("registerFailure");
            return Promise.reject(error);
          }
        );
    },

    addVehicle(state, carName) {
      var url = `${serverUrl}${urls.Vechicles.AddDeliveryVehicle}`;
      axios.post(url, { name: carName }).then(function (res) {
        state.commit("addVehicle", res.data);
      });
    },
    addRawMaterilType(state, rawMaterialName) {
      var url = `${serverUrl}${urls.RawMaterial.AddRawMaterialType}` 
      axios.post(url, { name: rawMaterialName }).then(function (res) {
        state.commit("addRawMaterilType", res.data);
      });
    },
    getCuvertureFormData(state) {
      var getMillsUrl = `${serverUrl}${urls.Mill.GetMills}`;
      var getRecipesUrl =`${serverUrl}${urls.Recipe.GetRecipes}`;
      var getRawMaterialTypes =`${serverUrl}${urls.RawMaterial.GetRawMaterialTypes}`;

      var fd = state.state.couvertureFormData;

      if (fd.mills.length == 0 || fd.recipes.length == 0 || fd.rawMaterialTypes.length == 0) {
        return new Promise((resolve, reject) => {
          axios
            .all([axios.get(getRawMaterialTypes), axios.get(getMillsUrl), axios.get(getRecipesUrl)])
            .then(
              axios.spread((rawMaterialTypes, mills, recipes) => {
                state.commit("setCouvertureFormData", {
                  mills: mills.data,
                  recipes: recipes.data,
                  rawMaterialTypes: rawMaterialTypes.data,
                });
                resolve({});
              })
            )
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        });
      }
    },
    getProductionHallData(state) {
      var barrelsUrl = `${serverUrl}${urls.Barrel.GetBarrels}`;
      var recipeCoatingUrl = `${serverUrl}${urls.RecipeCoating.GetRecipes}`;

      var phd = state.state.productionHall;

      if (phd.barrels.length == 0 || phd.recipeCoating.length == 0) {
        return new Promise((resolve, reject) => {
          axios
            .all([axios.get(barrelsUrl), axios.get(recipeCoatingUrl)])
            .then(
              axios.spread((barrels, recipeCoating) => {
                state.commit("setProductionHallData", {
                  barrels: barrels.data,
                  recipeCoating: recipeCoating.data,
                });
                resolve({});
              })
            )
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        });
      }
    },
    getDeliveryFromData(state) {
      var getCountryUrl = `${serverUrl}${urls.Country.GetCountry}`;
      var getProducerUrl = `${serverUrl}${urls.Producer.GetProducer}`;
      var getDeliveryQuestionsUrl = `${serverUrl}${urls.Delivery.GetDeliveryQuestions}`;
      var getRawMaterialTypesUrl = `${serverUrl}${urls.RawMaterial.GetRawMaterialTypes}`;
      var getDeliveryVehiclesUrl = `${serverUrl}${ urls.Vechicles.GetVechicles}`;

      var fd = state.state.deliveryFormData;
      if (fd.countries.length == 0 || fd.producers.length == 0 || fd.deliveryQuestions.length == 0 || fd.rawMaterialTypes.length == 0 || fd.vehicles.length == 0) {
        return new Promise((resolve, reject) => {
          axios
            .all([axios.get(getCountryUrl), axios.get(getProducerUrl), axios.get(getDeliveryQuestionsUrl), axios.get(getRawMaterialTypesUrl), axios.get(getDeliveryVehiclesUrl)])
            .then(
              axios.spread((countryRes, producerRes, questionsRes, rawMaterialsTypesRes, vehicles) => {
                state.commit("setDeliveryFormData", {
                  countries: countryRes.data,
                  producers: producerRes.data,
                  deliveryQuestions: questionsRes.data.map((x) => ({
                    deliveryQuestionId: x.id,
                    text: x.text,
                    isPassed: undefined,
                    comment: "",
                  })),
                  rawMaterialTypes: rawMaterialsTypesRes.data,
                  vehicles: vehicles.data,
                });
                resolve({});
              })
            )
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        });
      }
    },
    getUserFormData(state) {
      var rolesUrl =`${serverUrl}${urls.Auth.GetRoles}` ;
      var uf = state.state.userFormData;
      if (uf.roles.length == 0) {
        return new Promise((resolve, reject) => {
          axios
            .all([axios.get(rolesUrl)])
            .then(
              axios.spread((roles) => {
                state.commit("setUserFormData", {
                  roles: roles.data,
                });
                resolve({});
              })
            )
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        });
      }
    },
  },
  getters: {
    isLoggedIn: (state) => {
      if (state.token == undefined) {
        return false;
      }

      if (Date.now() >= state.tokenExpirationDate) {
        return false;
      }
      return true;
    },
    roles: (state) => {
      var decodedToken = jwt_decode(state.token);
      return decodedToken.role.split(",");
    },
    getCurrentDelivery: (state) => state.delivery,
  },
});

export default store;
